import React from 'react';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  action,
  className = '',
}) => {
  return (
    <div
      className={`
        flex flex-col items-center justify-center p-8 text-center
        border border-dashed border-white/[0.08] rounded-xl bg-white/[0.02]
        ${className}
      `}
    >
      {icon && (
        <div className="w-16 h-16 rounded-full bg-white/[0.04] flex items-center justify-center mb-4 text-3xl text-primary">
          {icon}
        </div>
      )}
      <h3 className="text-xl font-display font-bold text-[#F0F0F5] mb-2">
        {title}
      </h3>
      {description && (
        <p className="text-sm text-[#6B6B80] max-w-sm mb-6">
          {description}
        </p>
      )}
      {action && <div>{action}</div>}
    </div>
  );
};
